export const LEVEL_CONNECTION_TYPES = {
  FOUR_G: 1,
  WIFI: 2,
};

export const DEFAULT_LEVEL_CONNECTION_TYPE = LEVEL_CONNECTION_TYPES.FOUR_G;

export const LEVEL_CONNECTION_TYPE_OPTIONS = [
  { value: String(LEVEL_CONNECTION_TYPES.FOUR_G), label: "4G" },
  { value: String(LEVEL_CONNECTION_TYPES.WIFI), label: "Wifi" },
];

export const GSM_APN_CODES = {
  AIRTEL: 0,
  VODAFONE: 1,
  AIRTEL_IOT: 2,
  JIO1: 3,
  JIO2: 4,
  JIO3: 5,
};

export const DEFAULT_GSM_APN_CODE = GSM_APN_CODES.AIRTEL;

export const GSM_APN_OPTIONS = [
  { value: String(GSM_APN_CODES.AIRTEL), label: "Airtel" },
  { value: String(GSM_APN_CODES.VODAFONE), label: "Vodafone" },
  { value: String(GSM_APN_CODES.AIRTEL_IOT), label: "Airtel_IoT" },
  { value: String(GSM_APN_CODES.JIO1), label: "JIO1" },
  { value: String(GSM_APN_CODES.JIO2), label: "JIO2" },
  { value: String(GSM_APN_CODES.JIO3), label: "JIO3" },
];

export const GSM_APN_VALUE_SET = new Set(
  GSM_APN_OPTIONS.map((option) => option.value),
);

export const getLevelConnectionTypeCode = (connectionType) => {
  const numericValue = Number(connectionType);
  return numericValue === LEVEL_CONNECTION_TYPES.WIFI
    ? LEVEL_CONNECTION_TYPES.WIFI
    : LEVEL_CONNECTION_TYPES.FOUR_G;
};

export const getLevelConnectionTypeLabel = (connectionType) => {
  const code = getLevelConnectionTypeCode(connectionType);
  const option = LEVEL_CONNECTION_TYPE_OPTIONS.find(
    (item) => Number(item.value) === code,
  );

  return option?.label || "-";
};

export const isGsmApnCode = (gsmApnCode) =>
  GSM_APN_VALUE_SET.has(String(gsmApnCode));

export const getGsmApnCode = (gsmApnCode) => {
  const numericValue = Number(gsmApnCode);
  return isGsmApnCode(numericValue) ? numericValue : DEFAULT_GSM_APN_CODE;
};

export const getGsmApnLabel = (gsmApnCode) => {
  if (gsmApnCode === null || gsmApnCode === undefined || gsmApnCode === "") {
    return "-";
  }

  const option = GSM_APN_OPTIONS.find(
    (item) => item.value === String(gsmApnCode),
  );

  return option?.label || String(gsmApnCode);
};
